/* eslint-disable max-classes-per-file */
import { z } from 'zod';

import { Logger } from './Logger';

const errorSchema = z.object({
  code: z.number().optional(),
  message: z.string(),
  stack: z.string().optional(),
});

export class WalletAPIError extends Error {
  constructor(error: unknown, logger: Logger = console) {
    let msg = 'Wallet API error';

    if (error instanceof Error) {
      msg = error.message;
    } else if (typeof error === 'string') {
      msg = error;
    } else {
      try {
        const errorData = errorSchema.parse(error);
        msg = errorData.message;
      } catch (err) {
        logger.log(err);
      }
    }

    super(msg);
  }
}

export class WalletChangeNetworkFailed extends WalletAPIError {}

export class WalletChangeNetworkCancelled extends WalletAPIError {}

export class WalletConnectCancelled extends WalletAPIError {}

export class WalletDisconnectFailed extends WalletAPIError {}
